import React from 'react';
import { withDevice } from '@catalogo/core-connect/device';
import modules from '@catalogo/core-module-list/build/index.modal';

class SwitchModal extends React.Component {
  render() {
    const { component, device } = this.props;
    const modulesDevice = modules[device] || /* istanbul ignore next */ {};
    const Component = modulesDevice[component];

    if (!Component) {
      return null;
    }
    return <Component {...this.props} />;
  }
}

const SwitchModalConnected = withDevice(SwitchModal);
export { SwitchModalConnected as SwitchModal };
